/**
 * SÔNG + 2 CẦU CỦA ARENA — HÌNH HỌC THUẦN, **0 IMPORT** (kể cả 0 import `sim/arena/types.ts`).
 *
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * VÌ SAO FILE NÀY TỒN TẠI — VÀ VÌ SAO NÓ Ở `sim/` CHỨ KHÔNG Ở `scenes/`
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * Người dùng chốt nguyên văn: *"quái và nhân vật chỉ có thể đi qua cầu và không đi được qua sông"*.
 *
 * Đó là LUẬT CHƠI, không phải chi tiết đồ hoạ: sông chia sân thành 2 BỜ, và cầu là CỬA DUY NHẤT
 * giữa chúng. Bấm sai chỗ thả tướng, hoặc để unit lọt xuống nước, đều là lỗi luật. Vì nó là luật nên
 * nó thuộc tầng `sim/`, theo đúng quy ước repo (xem khối tương ứng ở đầu `deploy-pos.ts`).
 *
 * ⚠️⚠️ VÌ SAO **0 IMPORT** — KHÔNG PHẢI TÌNH CỜ, ĐỪNG "CHO GỌN" BẰNG CÁCH THÊM IMPORT.
 * File này là **vùng Phaser-free** của luật địa hình: 0 `import` ⇒ chạy được trong node của vitest,
 * và `tests/arena-river.test.ts` khoá được toàn bộ hình học bằng SỐ. Chỉ cần một `import` là mở
 * đường cho cả tầng sim (rồi tới Phaser) bị kéo vào vùng test thuần — đúng cái bẫy đã sập ở repo với
 * `src/render/arena-battle.ts` (`ReferenceError: window is not defined` từ `phaser.esm.js`).
 *
 * ⚠️ HỆ QUẢ CỐ Ý: các số ở đây được khai LẠI thay vì `import` từ `world.ts`. Nhìn qua thì đó là
 * "nguồn sự thật thứ hai", nhưng nó KHÔNG phải, và đây là lý do:
 *   · `world.ts` RE-EXPORT chính các hằng số này (`export { ARENA_RIVER, ... } from './river'`),
 *     nên chỉ có MỘT giá trị trong toàn bộ tiến trình — hai tên, một object.
 *   · `tests/arena-river.test.ts` đối chiếu TỪNG SỐ với hằng số thật của sim, nên lệch là đỏ ngay.
 * Đây là "bản sao có khoá" — cùng khuôn với `land-pick.ts` cũ, xem chú thích đầu file đó.
 *
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * SỐ ĐO TỪ ẢNH THẬT (`art/ai/arena-river.png`, 1328×800) QUY VỀ `1000×600`
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * Hệ số quy đổi: `sc = 800 / 600 = 1,3333` cho trục y, `1328 / 1000 = 1,328` cho trục x.
 *
 * | thứ          | px trong ảnh | world (1000×600) |
 * |--------------|--------------|------------------|
 * | mặt nước     | x 585–741    | x 440–555        |
 * | MẶT CẦU TRÊN  | y 135–284    | y 101,2–213,0    |
 * | MẶT CẦU DƯỚI  | y 496–648    | y 372,0–486,0    |
 *
 * ⚠️ SÔNG LẤY **439–560** — ẢNH MỚI LÀ NGUỒN SỰ THẬT (xem khối chú thích ở `ARENA_RIVER`).
 *
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * ⚠️⚠️ DẢI CẦU TRONG SIM **PHẢI NẰM TRONG MẶT CẦU VẼ** — BUG NGƯỜI DÙNG BÁO, ĐỌC KỸ
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * Lịch sử đã đổi hai lần, và CẢ HAI lần đều vì một câu của người dùng — ghi lại để đời sau không
 * "khôi phục" số cũ mà không biết chuyện gì đã xảy ra:
 *
 *   · LẦN 1 — người dùng: *"Cầu hơi bé, không quá nhiều lính và tướng qua được"*. Khi đó khổ sim là
 *     81 (đúng số ảnh GỐC), và tôi đã NỚI lên 160 (khổ 160, tâm 155/437) để thoả cảm giác "cầu rộng".
 *     ⚠️ Số đo khi đó cho thấy khổ 81 VẪN qua được hết (10 lính 13,1s · 50 lính 15,3s · 80 lính
 *     16,0s) — thứ cứu thông lượng là ĐỊNH TUYẾN QUA CẦU + RẢI ĐIỂM ĐẾN, không phải bề rộng. Nhưng
 *     "nới cho thoáng" vẫn được chọn vì nhanh hơn ~9% và có biên an toàn rộng hơn.
 *   · LẦN 2 (BUG HIỆN TẠI) — người dùng: *"Ở cầu dưới nhân vật đang đi được qua sông, có vẻ khung
 *     cầu bạn vẽ bị to hơn ảnh, cầu trên cũng bị nhé"* (kèm ảnh: tướng đứng trên NƯỚC, ngay TRÊN mặt
 *     cầu gỗ của cầu dưới). Đây là hệ quả TRỰC TIẾP của khổ 160: ảnh chỉ vẽ mặt gỗ ~112–114, còn
 *     sim cho unit đi trên 160 ⇒ **vùng chênh là NƯỚC mà unit được phép đứng**.
 *
 * 🔢 SỐ ĐO LẠI TỪ CHÍNH FILE ẢNH (quét điểm ảnh bằng `sharp`, dải sông `x` world 439–560):
 * | cầu      | mặt gỗ trên ảnh (world y) | dải sim CŨ | chênh CŨ |
 * |----------|---------------------------|------------|----------|
 * | TRÊN     | `[101,2, 213,0)` khổ 111,8 | `[75, 235)` khổ 160 | +26,2 trên / +22,0 dưới |
 * | DƯỚI     | `[372,0, 486,0)` khổ 114,0 | `[357, 517)` khổ 160 | +15,0 trên / +31,0 dưới |
 * Tâm cầu cũng lệch: sim 155/437 so với ảnh **157,1 / 429,0**.
 *
 * ⇒ CÁCH SỬA: thu dải sim xuống KHỚP mặt gỗ, **và inset một chút** (không lấy đúng mép gỗ): mép vẽ có
 * bo/ viền sáng nên `y` đúng bằng mép vẫn trông như đứng trên nước.
 *   · cầu TRÊN: tâm **157**, nửa khổ **52** ⇒ `[105, 209)` — inset **3,8** trên / **4,0** dưới;
 *   · cầu DƯỚI: tâm **429**, nửa khổ **52** ⇒ `[377, 481)` — inset **5,0** trên / **5,0** dưới;
 *   · ⇒ `ARENA_BRIDGE_HALF` 80 → **52** (khổ **104**).
 * Bất biến mới, và là thứ bài test khoá: **`ARENA_BRIDGE_TOP/BOTTOM` ⊆ `ARENA_BRIDGE_DECK_TOP/BOTTOM`**
 * (hai hằng số đo từ ảnh — xem chú thích chúng). Đổi ảnh thì PHẢI ĐO LẠI hai hằng số `DECK_*`.
 *
 * ⚠️ KHÔNG ĐƯỢC ĐỂ DẢI SIM RỘNG HƠN MẶT CẦU VẼ. Nghịch đảo điều này là mở lại đúng bug vừa sửa.
 *
 * ⚠️ KHỔ 104 CÓ LÀM HỎNG THÔNG LƯỢNG KHÔNG? **KHÔNG** — và lần này cũng KHÔNG suy luận, mà ĐO:
 * | khổ cầu | 10 lính | 20 lính | 50 lính | 80 lính |
 * |---------|---------|---------|---------|---------|
 * |  **104** (mới) | 12,5s | 12,5s | 12,5s | 12,5s |
 * |  **160** (cũ)  | 12,5s | 12,5s | 12,5s | 12,5s |
 * Tất cả đều qua hết, không con nào kẹt. Lý do vẫn là lý do cũ: thứ cứu thông lượng là ĐỊNH TUYẾN
 * (`moveToward`/ `stepTarget` trong `world.ts`), không phải bề rộng. 104 vẫn ≥ 2 ×
 * `ARENA_BRIDGE_LANE_MIN` (24) nên vẫn đủ chỗ cho nhiều làn.
 *
 * ⚠️ KẾT LUẬN NÀY ĐƯỢC KHOÁ BẰNG TEST: `tests/arena-river.test.ts` có (1) bài "DẢI SIM ⊆ MẶT CẦU
 * VẼ" đối chiếu trực tiếp với `ARENA_BRIDGE_DECK_*`, và (2) bài "THÔNG LƯỢNG CẦU" đo bằng mô phỏng
 * thật cho 10/20/30/50/80 lính. Ai nới dải sim ra ngoài mặt gỗ, hoặc ai hạ khổ cầu tới mức ùn tắc,
 * đều thấy test đỏ.
 */

/** Bề rộng thế giới — khai lại có chủ ý, xem khối chú thích đầu file. */
const WORLD_W = 1000;
const WORLD_H = 600;

/**
 * DẢI SÔNG — `x` chạy suốt từ `y = 0` tới `y = WORLD_H` (sông DỌC, cắt ngang sân thành 2 bờ).
 * Quy ước **half-open `[x0, x1)`** giống mọi dải khác của repo.
 *
 * ⚠️⚠️ SỐ ĐÃ ĐƯỢC CHỈNH THEO **ẢNH MỚI** (`art/ai/arena-river.png` bản Lead generate lại) — ĐỌC KỸ.
 * Bản chốt đầu tiên của tôi là `447 → 553` (rộng 106, suy từ ảnh CŨ). Lead generate lại ảnh theo số
 * đó rồi ĐO LẠI bằng script và ra **439,0 → 560,2** (rộng ~121): ảnh không khớp chính xác số yêu cầu,
 * lệch ~8 đơn vị mỗi bên.
 *
 * ⚠️ VÌ SAO LẦN NÀY TÔI ĐỔI **SIM THEO ẢNH** (ngược với lần trước, khi tôi bắt ảnh theo sim):
 *   · Ảnh là thứ NGƯỜI CHƠI NHÌN THẤY. Nếu sim cho quân đi qua chỗ ảnh vẽ là nước, hoặc chặn ở chỗ
 *     ảnh vẽ là bờ, thì người chơi thấy một lỗi — bất kể con số trong code "đúng thiết kế".
 *   · Sông rộng 121 hay 106 KHÔNG đổi gameplay: nó chỉ là một dải cấm, và cả hai bề rộng đều để lại
 *     hơn 430 đơn vị bờ mỗi bên. Không có ngưỡng nào phụ thuộc bề rộng sông (khác với CẦU — xem dưới).
 *   · Ảnh khó sửa chính xác hơn sim (Lead đã thử 3 lượt), nên chiều "sim theo ảnh" rẻ hơn.
 *
 * ⇒ `x0 = 439`, `x1 = 560`. Tâm `499,5` — lệch 0,5 so với tâm sân `500`, KHÔNG sao: sông không cần
 * đối xứng tuyệt đối để luật đúng, và bám ảnh quan trọng hơn. Có test khoá CẢ HAI mép bằng số.
 *
 * ⚠️ HỆ QUẢ PHẢI SỬA CÙNG LÚC: `deploy-pos.ts` (`OWN_SHORE_X`/ `ENEMY_SHORE_X`) chép 2 mép này vì
 * file đó 0-import — lệch là test `arena-deploy` đỏ ngay. Đây chính là lý do "bản sao có khoá" tồn
 * tại: nó biến một lỗi im lặng thành một lỗi ồn ào.
 */
export const ARENA_RIVER = {
  x0: 439,
  x1: 560,
  /** tâm sông — suy từ 2 mép, không khai tay (khai tay là nguồn sự thật thứ hai). */
  centerX: (439 + 560) / 2,
  width: 560 - 439,
} as const;

/**
 * NỬA KHỔ CẦU — nửa bề rộng **MẶT GỖ ĐI ĐƯỢC** theo trục Y. Xem khối chú thích đầu file về lý do **43**.
 *
 * ⚠️⚠️ SỐ NÀY ĐÃ QUA HAI LẦN SỬA, VÀ LẦN NÀY LÀ **HẸP LẠI** — ĐỌC KỸ, ĐỪNG "NỚI LẠI CHO THOÁNG":
 *   · `80` (khổ 160): rộng hơn mặt gỗ vẽ (~112–114) ⇒ unit đứng trên NƯỚC. Người dùng:
 *     *"Ở cầu dưới nhân vật đang đi được qua sông, có vẻ khung cầu bạn vẽ bị to hơn ảnh"* ⇒ hạ còn 52.
 *   · `52` (khổ 104): vẫn LẤN VÀO **THÀNH CẦU** (thanh đá hai bên mặt gỗ). Người dùng:
 *     *"Phần thành cầu từ mép sông vào đất liền nhân vật không được phép đi xuyên qua"* ⇒ hạ còn **43**.
 *
 * 🔢 SỐ ĐO LẠI TỪ `art/ai/arena-river.png` (giải mã PNG, quét cột giữa cầu, đọc màu từng hàng):
 *   · cầu TRÊN: đá 101–113 (mặt trên 103–109 + bóng 110–113) · **gỗ 114–199** · đá 202–210 · nước từ 216
 *   · cầu DƯỚI: đá 374–386 · **gỗ 387–472** · đá 473–484 · nước từ 485
 *   ⇒ hai mặt gỗ đều **86 đơn vị** (nửa khổ **43**) ⇒ `ARENA_BRIDGE_HALF = 43`.
 *
 * ⚠️ ĐÂY LÀ SỐ DUY NHẤT QUY ĐỊNH BỀ RỘNG CẢ 2 CẦU. Hai cầu CỐ Ý cùng khổ: người chơi phải đọc ra
 * "hai cửa như nhau, chọn cửa nào cũng được", chứ không phải "cầu trên là bản xịn, cầu dưới là bản lỗi".
 *
 * ⚠️ KHÔNG ĐƯỢC NÂNG SỐ NÀY LÊN mà không đối chiếu `ARENA_BRIDGE_DECK_*`: dải sim phải NẰM TRONG mặt gỗ
 * vẽ (có test khoá quan hệ đó), và phần `DECK − BRIDGE` chính là THÀNH CẦU — nay là vùng CẤM ĐI
 * (`isBridgeRailBlocked`). Nới ra là mở lại bug "unit đi xuyên thành cầu".
 */
export const ARENA_BRIDGE_HALF = 43;

/**
 * TÂM Y CỦA 2 CẦU — ĐO TỪ ẢNH, KHÔNG ĐẶT CHO ĐẸP.
 *
 * ⚠️⚠️ SỐ CŨ LÀ 155 / 437, VÀ NÓ LỆCH SO VỚI ẢNH: đo lại mặt gỗ trong `art/ai/arena-river.png` được
 * `[101,2, 213,0)` (tâm **157,1**) và `[372,0, 486,0)` (tâm **429,0**). Giữ tâm cũ thì dải sim vẫn
 * lệch khỏi hình ~2–8 đơn vị ngay cả khi đã hạ khổ — đúng loại lệch mà mắt người chơi nhận ra
 * ("sao qua cầu lại bị đẩy ra") nhưng không ai đo được nếu không quét ảnh.
 *
 * ⚠️ VÌ SAO KHÔNG ĐẶT ĐỐI XỨNG QUANH TÂM SÂN: ảnh vẽ cầu dưới ở tâm 429, không phải 445. Đặt 445 cho
 * "đẹp" là lệch 16 đơn vị so với hình. Giữ số ĐO TỪ ẢNH thì hình và luật khớp nhau.
 */
export const ARENA_BRIDGE_TOP_CENTER = 157;
export const ARENA_BRIDGE_BOTTOM_CENTER = 429;

/** Dải y của 1 cầu — `{ top, bottom }` theo quy ước half-open `[top, bottom)`. */
export interface BridgeBand {
  top: number;
  bottom: number;
}

/**
 * MẶT CẦU VẼ TRONG ẢNH (`art/ai/arena-river.png`) — HAI HẰNG SỐ NÀY LÀ "NGUỒN SỰ THẬT CỦA HÌNH VẼ".
 *
 * ⚠️⚠️ VÌ SAO PHẢI CÓ CHÚNG Ở TẦNG SIM: bug "unit đứng trên nước" sinh ra từ việc dải sim RỘNG HƠN
 * mặt gỗ mà không ai đối chiếu hai thứ với nhau. Khoá quan hệ `ARENA_BRIDGE_* ⊆ ARENA_BRIDGE_DECK_*`
 * bằng test biến "ảnh vẽ hẹp hơn luật" từ một lỗi im lặng thành một lỗi ồn ào.
 *
 * 🔢 ĐO BẰNG CÁCH QUÉT ĐIỂM ẢNH (dải sông `x` world 439–560 ⇒ px 583–744), quy đổi `world_y = px_y ×
 * 600/800`. Giá trị dưới đây là mép NGOÀI của gỗ kể cả viền sáng/ bo góc:
 *   · cầu TRÊN: px y `135…284` ⇒ world `101,2 … 213,0` (khổ 111,8)
 *   · cầu DƯỚI: px y `496…648` ⇒ world `372,0 … 486,0` (khổ 114,0)
 *
 * ⚠️⚠️ ĐỔI ẢNH (`arena-river.png`) THÌ **PHẢI ĐO LẠI HAI HẰNG SỐ NÀY**, không được chỉnh tay theo cảm
 * giác. Cách đo đã dùng (chạy được lại): giải mã PNG, lấy trung bình màu từng hàng trong dải sông,
 * hàng nào nâu (R > B + 25) là gỗ. Có test `tests/arena-river.test.ts` đối chiếu `ARENA_BRIDGE_*` với
 * hai số này — lệch là đỏ.
 */
export const ARENA_BRIDGE_DECK_TOP: BridgeBand = { top: 101.2, bottom: 213 };

/** Xem `ARENA_BRIDGE_DECK_TOP` — cùng cách đo, cùng quy tắc "đổi ảnh phải đo lại". */
export const ARENA_BRIDGE_DECK_BOTTOM: BridgeBand = { top: 372, bottom: 486 };

/**
 * DẢI X CỦA MẶT CẦU VẼ TRONG ẢNH — SÀN GỖ **VÀ** 2 TRỤ ĐÁ HAI ĐẦU.
 *
 * ⚠️⚠️ VÌ SAO PHẢI CÓ (BUG NGƯỜI DÙNG BÁO): *"Không được thả tướng lên cầu"*.
 * `isValidDeployPos` chỉ chặn theo `ARENA_RIVER` (`x ∈ [439, 560)`) nên nó chặn được PHẦN CẦU NẰM
 * TRÊN SÔNG — nhưng cầu vẽ trong ảnh còn THÒ HẲN SANG HAI BỜ (trụ đá + sàn gỗ), và vùng thò đó nằm
 * trong nửa sân người chơi nên luật cũ CHO THẢ. Người chơi kéo tướng vào đầu cầu bên mình ⇒ tướng
 * đứng trên mặt gỗ, đúng thứ vừa bị cấm.
 *
 * 🔢 ĐO TỪ `art/ai/arena-river.png` (cách đo: giải mã PNG, quét cột trong dải y của cầu, tìm mép
 * ngoài của trụ đá/sàn gỗ; đối chiếu chéo bằng ảnh chụp canvas 1000×600 = 1:1 với world):
 *   · mép TRÁI  = **361**  (trụ đá trái) — mép PHẢI = **638** (trụ đá phải);
 *   · khổ cầu vẽ = **277**, ĐỐI XỨNG quanh tâm sông 499,5: `499,5 − 361 = 138,5` và
 *     `638 − 499,5 = 138,5` ⇒ mỗi bên thò ra **78** đơn vị ngoài mép sông (439/ 560).
 * ⚠️ Tính đối xứng này là PHÉP KIỂM của phép đo (không phải "làm tròn cho đẹp"): đo lệch 2 bên là
 * dấu hiệu đã bắt nhầm một prop khác (thùng gỗ/ cây cảnh) chứ không phải trụ cầu.
 *
 * ⚠️ ĐỔI ẢNH (`arena-river.png`) THÌ PHẢI ĐO LẠI HAI HẰNG SỐ NÀY, cùng lúc với `ARENA_BRIDGE_DECK_*`
 * (y). `tests/arena-river.test.ts` khoá quan hệ "dải sông ⊆ dải x mặt cầu" + tính đối xứng, nên lệch
 * là đỏ ngay.
 */
export const ARENA_BRIDGE_DECK_X0 = 361;
export const ARENA_BRIDGE_DECK_X1 = 638;

/** Dải y của CẦU TRÊN: `157 ± 52` = `[105, 209)`. Inset 3,8/ 4,0 so với mặt gỗ `[101,2, 213,0)`. */
export const ARENA_BRIDGE_TOP: BridgeBand = {
  top: ARENA_BRIDGE_TOP_CENTER - ARENA_BRIDGE_HALF,
  bottom: ARENA_BRIDGE_TOP_CENTER + ARENA_BRIDGE_HALF,
};

/** Dải y của CẦU DƯỚI: `429 ± 52` = `[377, 481)`. Inset 5,0/ 5,0 so với mặt gỗ `[372,0, 486,0)`. */
export const ARENA_BRIDGE_BOTTOM: BridgeBand = {
  top: ARENA_BRIDGE_BOTTOM_CENTER - ARENA_BRIDGE_HALF,
  bottom: ARENA_BRIDGE_BOTTOM_CENTER + ARENA_BRIDGE_HALF,
};

/** Cả 2 cầu, theo thứ tự từ trên xuống — dùng cho vòng lặp và cho việc chọn cầu gần nhất. */
export const ARENA_BRIDGES: readonly BridgeBand[] = [ARENA_BRIDGE_TOP, ARENA_BRIDGE_BOTTOM];

/**
 * HAI MẶT CẦU **VẼ** — XẾP CÙNG THỨ TỰ VỚI `ARENA_BRIDGES` (chỉ số `i` nói về CÙNG một cây cầu).
 *
 * ⚠️⚠️ THỨ TỰ LÀ HỢP ĐỒNG, KHÔNG PHẢI CHI TIẾT TRÌNH BÀY: `isBridgeRailBlocked`/ `pushOutBridgeRail` lấy
 * `DECKS[i]` đi kèm `BRIDGES[i]` để suy ra THÀNH CẦU — đảo thứ tự một trong hai mảng là thành cầu của
 * cầu trên bị tính cho cầu dưới. `tests/arena-river.test.ts` khoá đúng cặp chỉ số này.
 */
export const ARENA_BRIDGE_DECKS: readonly BridgeBand[] = [ARENA_BRIDGE_DECK_TOP, ARENA_BRIDGE_DECK_BOTTOM];

/**
 * BỀ RỘNG TỐI THIỂU ĐỂ 2 UNIT ĐI SONG SONG TRÊN CẦU MÀ KHÔNG ĐẨY NHAU.
 *
 * ⚠️ ĐÂY LÀ GỐC RỄ CỦA YÊU CẦU "CẦU PHẢI RỘNG", KHÔNG PHẢI MỘT CON SỐ TRANG TRÍ.
 * `separateUnits` đẩy 2 unit ra khi `khoảng cách < r₁ + r₂`. Với lính thường, `radius = arenaDist(14)`
 * ≈ 5,83 ⇒ cần lệch nhau ít nhất ~11,7 theo trục y. Nhưng unit đi trên cầu còn phải nhường nhau
 * theo trục x (vì `separateUnits` đẩy theo VECTO nối 2 tâm, không chỉ trục y), nên bề rộng hữu dụng
 * phải rộng hơn khoảng cách tối thiểu đó — chia đôi bề rộng cầu trừ đi bán kính.
 *
 * 🔢 `ARENA_BRIDGE_HALF = 52` ⇒ khổ cầu 104 ⇒ vẫn thoải mái chứa 2–3 làn lính (mỗi làn ~12). Con số
 * này chỉ để DIỄN GIẢI, không tham gia tính toán: bài test thông lượng đo BẰNG MÔ PHỎNG THẬT, không
 * bằng công thức này. Giữ nó lại vì nó là lý do thiết kế, và vì nó cho người đọc sau một mốc để biết
 * "hẹp hơn mức này là hỏng".
 *
 * ⚠️ QUAN HỆ PHẢI GIỮ: `ARENA_BRIDGE_HALF × 2 ≥ 2 × ARENA_BRIDGE_LANE_MIN` (104 ≥ 24) — nếu ai hạ
 * khổ cầu xuống dưới mức 2 làn thì luồng quân hai chiều bắt đầu triệt tiêu nhau.
 */
export const ARENA_BRIDGE_LANE_MIN = 12;

// ════════════════════════════════════════════════════════════════════════════
// 1. HÌNH HỌC THUẦN — mọi thứ khác suy từ 3 hàm dưới đây
// ════════════════════════════════════════════════════════════════════════════

/**
 * MỘT ĐIỂM CÓ NẰM TRONG LÒNG SÔNG KHÔNG (bất kể có cầu hay không).
 *
 * Quy ước half-open `[x0, x1)` GIỐNG MỌI DẢI KHÁC của repo (xem `landBandOf` cũ/ `ARENA_RIVER`):
 * mỗi dải sở hữu mép trái và nhường mép phải cho dải kế. Nhờ vậy một `x` không bao giờ thuộc 2 vùng,
 * và `x = 553` là bờ PHẢI (đi được), không phải sông — chi tiết này có test khoá riêng.
 *
 * ⚠️ `NaN`/ `Infinity` ⇒ `false` (coi như "không phải sông"). Lý do chọn `false` chứ không phải
 * `true`: hàm này được dùng để CHẶN di chuyển, mà chặn nhầm một toạ độ rác sẽ làm unit đứng im vĩnh
 * viễn ở một chỗ không ai đoán ra. `false` = "không có ý kiến", và mọi phép kiểm hợp lệ khác
 * (`isValidDeployPos`, `ARENA_WORLD`) đã chặn toạ độ rác ở cửa vào rồi.
 */
export function inRiver(x: number): boolean {
  if (!Number.isFinite(x)) return false;
  return x >= ARENA_RIVER.x0 && x < ARENA_RIVER.x1;
}

/**
 * `y` NÀY CÓ NẰM TRÊN CẦU NÀO KHÔNG (cầu trên HOẶC cầu dưới).
 *
 * Dùng half-open `[top, bottom)` cho mỗi cầu, cùng quy ước với `inRiver`.
 * ⚠️ Vì sao dùng `onBridge` (không kiểm `x`): đây là câu hỏi "y có thuộc khổ cầu không", độc lập
 * với việc unit đang ở bờ hay đang ở giữa sông. Ghép `x` vào đây sẽ làm hàm không trả lời được câu
 * hỏi đó nữa, và mọi chỗ gọi phải tự ghép lại — mở đường cho 2 bản luật lệch nhau.
 */
export function onBridge(y: number): boolean {
  if (!Number.isFinite(y)) return false;
  for (const b of ARENA_BRIDGES) {
    if (y >= b.top && y < b.bottom) return true;
  }
  return false;
}

/**
 * MỘT ĐIỂM CÓ NẰM TRÊN **MẶT CẦU VẼ** KHÔNG (dải x của sàn gỗ/ trụ đá × dải y của mặt gỗ).
 *
 * ⚠️⚠️ KHÁC `onBridge` CÓ CHỦ Ý — ĐỪNG GỘP HAI HÀM:
 *   · `onBridge(y)` hỏi *"y này có thuộc khổ cầu không"*, KHÔNG kiểm `x`. Nó là câu hỏi của LUẬT ĐI LẠI:
 *     unit ở giữa sông mà `y` thuộc cầu thì được đi qua (`isRiverBlocked`), còn ở bờ thì `x` không
 *     quan trọng. Ghép `x` vào đó sẽ làm hàm không trả lời được câu hỏi đó nữa (xem chú thích `onBridge`).
 *   · hàm NÀY hỏi *"điểm (x,y) có nằm trên hình cái cầu không"* — câu hỏi của LUẬT THẢ QUÂN, nơi cả
 *     hai trục đều có nghĩa. Cầu là ĐƯỜNG ĐI, không phải chỗ ĐẶT quân (người dùng: *"Không được thả
 *     tướng lên cầu"*), và "cái cầu" mà mắt người chơi thấy gồm cả phần thò sang hai bờ.
 *
 * Dùng dải Y của **MẶT GỖ VẼ** (`ARENA_BRIDGE_DECK_*`), KHÔNG phải dải luật (`ARENA_BRIDGE_*`): dải
 * luật inset vào trong mặt gỗ (~4 đơn vị mỗi mép), nên lấy dải luật sẽ còn một rìa gỗ mỏng vẫn thả được.
 * `NaN`/ `Infinity` ⇒ `false` (cùng quy ước "không có ý kiến" như `inRiver`/ `onBridge`).
 */
export function inBridgeDeck(x: number, y: number): boolean {
  if (!Number.isFinite(x) || !Number.isFinite(y)) return false;
  if (x < ARENA_BRIDGE_DECK_X0 || x >= ARENA_BRIDGE_DECK_X1) return false;
  return (
    (y >= ARENA_BRIDGE_DECK_TOP.top && y < ARENA_BRIDGE_DECK_TOP.bottom) ||
    (y >= ARENA_BRIDGE_DECK_BOTTOM.top && y < ARENA_BRIDGE_DECK_BOTTOM.bottom)
  );
}

/**
 * ⚠️⚠️ HÀM QUAN TRỌNG NHẤT CỦA FILE: ĐIỂM NÀY CÓ BỊ SÔNG CHẶN KHÔNG (nước, và KHÔNG ở trên cầu).
 *
 * Bất biến mà cả tính năng dựa vào, phát biểu CHÍNH XÁC:
 *   **mọi unit, ở mọi tick, đều thoả `!isRiverBlocked(u.x, u.y)`.**
 *
 * ⚠️ ĐỌC KỸ: "KHÔNG Ở TRONG SÔNG" LÀ CHƯA ĐỦ. Một unit đứng trên cầu vẫn có `x` nằm giữa dải sông
 * (`inRiver(x) === true`) — và đó là ĐIỀU ĐÚNG, cầu nằm trên sông. Vì vậy bất biến phải là
 * `!isRiverBlocked`, KHÔNG phải `!inRiver`. Viết sai vế này thì bài test bất biến sẽ đỏ ở mọi unit
 * đang qua cầu — hoặc tệ hơn, bị "sửa" bằng cách cấm unit lên cầu.
 */
export function isRiverBlocked(x: number, y: number): boolean {
  /*
   * ⚠️⚠️ PHẢI KIỂM CẢ HAI TOẠ ĐỘ HỮU HẠN — BUG CÓ THẬT, BÀI TEST NaN CỦA TÔI BẮT ĐƯỢC.
   * Bản đầu viết `return inRiver(x) && !onBridge(y);`. Với `(500, NaN)`: `inRiver(500)` = true, mà
   * `onBridge(NaN)` = false (hàm đó chặn NaN, xem chú thích nó) ⇒ `!false` = true ⇒ hàm trả **true**
   * = "bị chặn". Tức một `y` RÁC bị coi là "đang trong sông", và `pushOutOfRiver` sẽ KÉO unit về
   * cầu gần nhất — mỗi tick, mãi mãi, vì nắn xong `y` vẫn là NaN.
   *
   * Đây đúng là loại "hai hàm chặn rác khác nhau ghép lại thành một lỗ" mà chú thích ở `inRiver`/
   * `onBridge` nói tới: mỗi hàm tự đúng, nhưng phép ghép thì sai. Cách sửa là chặn rác NGAY Ở ĐÂY
   * thay vì tin vào hai hàm con.
   */
  if (!Number.isFinite(x) || !Number.isFinite(y)) return false;
  return inRiver(x) && !onBridge(y);
}

/**
 * ⚠️⚠️ **THÀNH CẦU** (lan can/ trụ đá hai bên mặt gỗ) — ĐẶC, KHÔNG ĐI QUA ĐƯỢC. HÀM MỚI 02/10/2026.
 *
 * Người dùng: *"Phần thành cầu từ mép sông vào đất liền nhân vật không được phép đi xuyên qua nhé"*.
 *
 * THÀNH CẦU = **phần ĐÃ VẼ của cây cầu TRỪ mặt gỗ đi được**: `DECK − BRIDGE`, cả hai đều là số ĐO TỪ
 * ẢNH (xem bảng ở khối đầu file) nên không có hằng số mới nào phải bảo trì.
 *
 * ⚠️⚠️ VÌ SAO PHẢI CÓ HÀM NÀY — `isRiverBlocked` KHÔNG CHẶN ĐƯỢC VÙNG NÀY:
 * luật sông chỉ đúng khi `x` nằm TRONG dải sông (`[439, 560)`), còn cầu vẽ THÒ HẲN SANG HAI BỜ
 * (`DECK_X0..X1 = 361..638`). Trên phần thò đó, thành cầu là một bức tường đá mà unit đi xuyên qua
 * như không có gì — đúng thứ người dùng thấy. Bất biến cũ `!isRiverBlocked` KHÔNG bắt được vì `x` ở
 * đó không phải sông.
 *
 * ⚠️ QUAN HỆ PHẢI GIỮ (có test): `BRIDGE ⊆ DECK`, nên `DECK − BRIDGE` là hai dải rời nhau (trên/ dưới
 * mặt gỗ). Nếu ai nới `ARENA_BRIDGE_HALF` ra bằng `DECK` thì hàm này không chặn gì nữa — đúng lúc bug
 * quay lại, nên test khoá luôn "thành cầu phải CÓ BỀ DÀY > 0".
 *
 * `NaN`/ `Infinity` ⇒ `false` (cùng quy ước "không có ý kiến" như `inRiver`).
 */
export function isBridgeRailBlocked(x: number, y: number): boolean {
  const rail = bridgeRailAt(x, y);
  return rail !== null;
}

/**
 * DẢI THÀNH CẦU CHỨA ĐIỂM `(x,y)` — `null` nếu điểm không nằm trên thành cầu nào.
 *
 * Trả kèm `deckTop`/`deckBottom` (mép NGOÀI của cây cầu vẽ) và `bandTop`/`bandBottom` (mép mặt gỗ) để
 * `pushOutBridgeRail` biết phải nắn về phía nào mà không phải tra lại bảng — hai hàm dùng CHUNG một phép
 * phân loại, không có bản sao thứ hai của luật.
 */
export function bridgeRailAt(
  x: number,
  y: number,
): { top: number; bottom: number; deckTop: number; deckBottom: number; bandTop: number; bandBottom: number } | null {
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
  if (x < ARENA_BRIDGE_DECK_X0 || x >= ARENA_BRIDGE_DECK_X1) return null;
  for (let i = 0; i < ARENA_BRIDGES.length; i++) {
    const b = ARENA_BRIDGES[i];
    const deck = ARENA_BRIDGE_DECKS[i];
    if (!b || !deck) continue;
    const common = { deckTop: deck.top, deckBottom: deck.bottom, bandTop: b.top, bandBottom: b.bottom };
    /* thành TRÊN: từ mép ngoài của cầu vẽ tới mép mặt gỗ */
    if (y >= deck.top && y < b.top) return { top: deck.top, bottom: b.top, ...common };
    /* thành DƯỚI: từ mép mặt gỗ tới mép ngoài của cầu vẽ */
    if (y >= b.bottom && y < deck.bottom) return { top: b.bottom, bottom: deck.bottom, ...common };
  }
  return null;
}

/**
 * `x` CÓ NẰM TRONG DẢI X CỦA CẦU **VẼ** KHÔNG (kể cả hai đầu cầu THÒ SANG ĐẤT LIỀN).
 *
 * ⚠️ ĐÂY LÀ CÂU HỎI CỦA **ĐỊNH TUYẾN**, KHÔNG PHẢI CỦA VIỆC ĐI ĐƯỢC. Trong dải x này (`[361, 638)`)
 * có tới **4 BỨC THÀNH** nằm ngang (2 thành mỗi cầu), nên một unit đang ở trong dải mà đổi `y` bừa là
 * đâm vào thành — kể cả khi `x` của nó đang ở trên ĐẤT LIỀN (đó chính là phần "thành cầu từ mép sông
 * vào đất liền" mà người dùng báo). `world.ts` dùng hàm này để biết khi nào phải đi VÒNG RA NGOÀI dải
 * rồi mới đổi `y` (xem `stepTarget`/ `detourBridgeRail`).
 *
 * Dùng chung `ARENA_BRIDGE_DECK_X0/X1` với `inBridgeDeck`, half-open `[x0, x1)` như mọi dải khác.
 */
export function inBridgeDeckX(x: number): boolean {
  if (!Number.isFinite(x)) return false;
  return x >= ARENA_BRIDGE_DECK_X0 && x < ARENA_BRIDGE_DECK_X1;
}

/**
 * ĐOẠN THẲNG `(x0,y0) → (x1,y1)` CÓ CẮT **THÀNH CẦU** NÀO KHÔNG.
 *
 * ⚠️⚠️ VÌ SAO CẦN ĐẾN HÌNH HỌC ĐOẠN THẲNG (chứ không chỉ hỏi "điểm hiện tại có trong thành không"):
 * unit đi theo ĐOẠN từ vị trí hiện tại tới đích của chặng. Nếu chỉ kiểm điểm ĐẦU, một unit đang đứng
 * NGOÀI dải trụ cầu (ví dụ `x = 350`) vẫn nhận được một đích mà đường thẳng tới đó CHUI VÀO dải rồi
 * cắt thành (ví dụ đích `(400, 300)` khi nó đang ở `(350, 500)`: đoạn cắt thành dưới của cầu dưới tại
 * `x ≈ 380`). Khi đó phép nắn ở cuối tick sẽ đẩy nó ra, tick sau nó lại đi vào ⇒ **rung/ kẹt tại chỗ**
 * — đúng loại lỗi mà bài "nông dân không được kẹt" bắt. Kiểm cả ĐOẠN thì `world.ts` buộc unit ĐỔI `y`
 * TRƯỚC khi vào dải (xem `detourBridgeRail`), nên nó không bao giờ đâm vào thành.
 *
 * ⚠️ THÀNH CẦU CHỈ TỒN TẠI TRONG DẢI X CỦA CẦU VẼ: đoạn thẳng chỉ "cắt thành" nếu phần `x` của nó
 * trong lúc `y` đi qua dải thành có giao với `[ARENA_BRIDGE_DECK_X0, ARENA_BRIDGE_DECK_X1)`.
 *
 * `NaN`/ `Infinity` ⇒ `false` (cùng quy ước "không có ý kiến" như `inRiver`).
 */
export function segmentCrossesBridgeRail(x0: number, y0: number, x1: number, y1: number): boolean {
  if (!Number.isFinite(x0) || !Number.isFinite(y0) || !Number.isFinite(x1) || !Number.isFinite(y1)) {
    return false;
  }
  for (let i = 0; i < ARENA_BRIDGES.length; i++) {
    const b = ARENA_BRIDGES[i];
    const deck = ARENA_BRIDGE_DECKS[i];
    if (!b || !deck) continue;
    /* thành TRÊN = `[deck.top, b.top)`; thành DƯỚI = `[b.bottom, deck.bottom)` */
    if (segmentCrossesBand(x0, y0, x1, y1, deck.top, b.top)) return true;
    if (segmentCrossesBand(x0, y0, x1, y1, b.bottom, deck.bottom)) return true;
  }
  return false;
}

/**
 * ĐOẠN THẲNG CÓ CẮT DẢI `y ∈ [bandTop, bandBottom)` **BÊN TRONG DẢI X CỦA CẦU** KHÔNG — hàm con của
 * `segmentCrossesBridgeRail`, không export (chỉ một luật, một chỗ cài).
 *
 * Cách làm: quy về khoảng tham số `t ∈ [0,1]` mà `y(t)` nằm trong dải, rồi kiểm khoảng `x` tương ứng.
 * ⚠️ ĐOẠN NGANG (`dy = 0`) phải xử riêng: chia cho `dy` sẽ ra `Infinity`/ `NaN`, và `NaN` im lặng làm
 * phép kiểm luôn trả `false` — đúng kiểu lỗi "không ném, chỉ sai".
 */
function segmentCrossesBand(x0: number, y0: number, x1: number, y1: number, bandTop: number, bandBottom: number): boolean {
  const dy = y1 - y0;
  const dx = x1 - x0;
  let t0 = 0;
  let t1 = 1;
  if (dy === 0) {
    if (!(y0 >= bandTop && y0 < bandBottom)) return false;
  } else {
    const ta = (bandTop - y0) / dy;
    const tb = (bandBottom - y0) / dy;
    t0 = Math.max(t0, Math.min(ta, tb));
    t1 = Math.min(t1, Math.max(ta, tb));
    if (t0 > t1) return false;
  }
  const xa = x0 + dx * t0;
  const xb = x0 + dx * t1;
  return Math.max(xa, xb) > ARENA_BRIDGE_DECK_X0 && Math.min(xa, xb) < ARENA_BRIDGE_DECK_X1;
}

/**
 * ⚠️⚠️ **ĐỊA HÌNH CẤM ĐI** — HÀM MÀ MỌI ĐƯỜNG DI CHUYỂN PHẢI DÙNG (thay cho `isRiverBlocked` đơn lẻ).
 *
 * = SÔNG (ngoài vùng cầu) **HOẶC** THÀNH CẦU. Bất biến của trận nay phát biểu là:
 *   **mọi unit, ở mọi tick, đều thoả `!isTerrainBlocked(u.x, u.y)`.**
 *
 * ⚠️ VÌ SAO KHÔNG SỬA THẲNG `isRiverBlocked` CHO GỌN: tên hàm đó nói đúng một luật (SÔNG), và nó được
 * dùng ở nhiều chỗ để hỏi câu hỏi hẹp ("có phải nước không"). Gộp thành câu hỏi rộng rồi đổi nghĩa ngầm
 * là mở đường cho code cũ hiểu sai. Thêm một hàm mới, và đổi TÊN hàm nắn (`pushOutOfRiver` →
 * `pushOutOfTerrain`) để mọi chỗ gọi phải đọc lại luật.
 */
export function isTerrainBlocked(x: number, y: number): boolean {
  return isRiverBlocked(x, y) || isBridgeRailBlocked(x, y);
}

/**
 * NẮN `y` RA KHỎI THÀNH CẦU — trả `y` hợp lệ GẦN NHẤT, hoặc `null` nếu điểm không nằm trên thành cầu.
 *
 * HÀM THUẦN (để test được bằng số); `world.ts` chỉ gọi rồi ghi lại `u.y`.
 *
 * ⚠️ CHỌN MÉP **GẦN HƠN**: ra NGOÀI cầu (`deckTop − standoff`, tức đi vòng qua đầu cầu) hay vào MẶT GỖ
 * (`bandTop + standoff`, tức leo lên cầu). Với bước đi vài đơn vị mỗi tick, unit luôn ở SÁT mép vừa chạm
 * nên phép nắn luôn đẩy nó TRỞ RA ⇒ không có chuyện "đi xuyên" qua thành. Nếu vì va chạm mà nó lọt sâu
 * vào trong thì phép nắn kéo nó lên mặt gỗ — vẫn là vị trí hợp lệ, không kẹt trong tường.
 *
 * ⚠️ `standoff` = `bán kính + lề` (xem `pushOutOfTerrain`): cả THÂN unit phải ra khỏi mép, không chỉ tâm.
 */
export function pushOutBridgeRail(x: number, y: number, standoff = 0): number | null {
  const rail = bridgeRailAt(x, y);
  if (!rail) return null;
  const m = Number.isFinite(standoff) && standoff > 0 ? standoff : 0;
  /* Thành TRÊN (nằm trên mặt gỗ): ra ngoài = `deckTop − m`, vào mặt gỗ = `bandTop + m`. */
  if (rail.bottom === rail.bandTop) {
    const outY = rail.deckTop - m;
    const inY = rail.bandTop + m;
    return Math.abs(y - outY) <= Math.abs(y - inY) ? outY : inY;
  }
  /* Thành DƯỚI: vào mặt gỗ = `bandBottom − m`, ra ngoài = `deckBottom + m`. */
  const inY = rail.bandBottom - m;
  const outY = rail.deckBottom + m;
  return Math.abs(y - inY) <= Math.abs(y - outY) ? inY : outY;
}

/**
 * CẦU GẦN NHẤT THEO TRỤC Y — trả CHỈ SỐ vào `ARENA_BRIDGES` (0 = trên, 1 = dưới).
 *
 * Dùng để định tuyến 2 chặng: unit ở bờ này muốn sang bờ kia thì đi tới cầu gần nó nhất, qua cầu,
 * rồi mới tới đích (xem `crossingY` / `moveToward` trong `world.ts`).
 *
 * ⚠️ CHỌN THEO `y` CỦA CHÍNH UNIT, KHÔNG theo đích: đích có thể ở tận mép đối diện, và đi tới cầu
 * gần ĐÍCH sẽ bắt unit chạy dọc bờ sông một quãng dài trong khi có cầu ngay cạnh nó. Quy tắc "cầu
 * gần nhất với MÌNH" cho đường đi ngắn hơn và ổn định hơn (unit không đổi ý giữa đường).
 *
 * ⚠️ HOÀ (2 cầu cách đều) ⇒ trả cầu TRÊN (index 0) theo đúng thứ tự `ARENA_BRIDGES`. Cần một quy
 * tắc CỐ ĐỊNH chứ không "sao cũng được": nếu kết quả phụ thuộc thứ tự duyệt thì hai world cùng seed
 * có thể chọn cầu khác nhau, phá tính tất định (hợp đồng của `world.ts`).
 */
export function nearestBridgeIndex(y: number): number {
  if (!Number.isFinite(y)) return 0;
  let best = 0;
  let bestD = Infinity;
  for (let i = 0; i < ARENA_BRIDGES.length; i++) {
    const b = ARENA_BRIDGES[i];
    const cy = (b.top + b.bottom) / 2;
    const d = Math.abs(y - cy);
    if (d < bestD) {
      bestD = d;
      best = i;
    }
  }
  return best;
}

/** Tâm y của cầu theo chỉ số — tiện cho chỗ gọi, không phải tự tính `(top+bottom)/2`. */
export function bridgeCenterY(index: number): number {
  const b = ARENA_BRIDGES[index] ?? ARENA_BRIDGE_TOP;
  return (b.top + b.bottom) / 2;
}

/**
 * CẦU GẦN NHẤT ĐỂ ĐI TỪ `y` SANG PHÍA BỜ BÊN KIA — trả **y tâm cầu**, kẹp vào trong khổ cầu.
 *
 * ⚠️⚠️ VÌ SAO KẸP VÀO TRONG KHỔ CẦU (không trả thẳng tâm): tâm cầu là một ĐƯỜNG, còn unit có bán
 * kính. Nếu mọi unit đều nhắm ĐÚNG tâm cầu thì chúng xếp thành MỘT HÀNG DỌC và `separateUnits` đẩy
 * nhau ra khỏi hàng — chính là cơ chế ùn tắc đã ghi trong `world.ts`. Kẹp vào `[top + r, bottom - r]`
 * cho phép unit rải ra theo chiều rộng cầu, và đó là nửa còn lại của "biện pháp chống ùn tắc"
 * (nửa kia là nới bề rộng — xem khối chú thích đầu file).
 *
 * ⚠️ `margin` RÁC (âm/ NaN) ⇒ coi như 0 (nhắm tâm cầu). Không ném lỗi: đây là hàm hình học chạy
 * mỗi tick cho mọi unit, ném lỗi ở đây là giết cả vòng lặp game vì một tham số hỏng.
 */
export function crossingY(y: number, margin = 0): number {
  const b = ARENA_BRIDGES[nearestBridgeIndex(y)];
  const cy = (b.top + b.bottom) / 2;
  const m = Number.isFinite(margin) && margin > 0 ? margin : 0;
  const lo = b.top + m;
  const hi = b.bottom - m;
  // khổ cầu hẹp hơn 2×margin (chỉ xảy ra nếu ai đó thu cầu xuống dưới ~2× bán kính unit) ⇒ về tâm
  if (lo >= hi) return cy;
  return Math.min(hi, Math.max(lo, cy));
}

/**
 * BỜ NÀO — `'left'` nếu `x` nằm bên trái sông, `'right'` nếu bên phải, `null` nếu ĐANG Ở TRONG SÔNG.
 *
 * ⚠️ BA KẾT CỤC, KHÔNG PHẢI HAI — và kết cục thứ ba là thứ dễ bị "đơn giản hoá" mất.
 * `x` nằm giữa sông (kể cả trên cầu) KHÔNG thuộc bờ nào. Nếu gộp nó vào `'left'` (kiểu `x < centerX`
 * thì left) thì unit đang đi trên cầu sẽ được coi là "đã sang bờ trái", và phép định tuyến 2 chặng
 * sẽ DỪNG giữa cầu — unit đứng lại giữa sông vĩnh viễn. Đó đúng là lỗi mà bài test thông lượng bắt.
 */
export function shoreOf(x: number): 'left' | 'right' | null {
  if (!Number.isFinite(x)) return null;
  if (x < ARENA_RIVER.x0) return 'left';
  if (x >= ARENA_RIVER.x1) return 'right';
  return null; // đang trong dải sông (trên cầu hoặc dưới nước)
}

/** Bề rộng tối đa được dùng làm `margin` khi rải unit trên cầu — nửa khổ cầu. */
export const ARENA_BRIDGE_INNER_HALF = ARENA_BRIDGE_HALF;

/** Kích thước thế giới — khai lại để file 0-import vẫn tự kiểm được hình học (xem `ARENA_WORLD`). */
export const RIVER_WORLD = { w: WORLD_W, h: WORLD_H } as const;
